
export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      {/* Campaign Banner - Below Navbar */}
      <div className="relative z-10 w-full bg-gradient-to-r from-[#D4AF37] via-[#F5D060] to-[#D4AF37] py-3 px-4 text-center shadow-md" style={{ marginTop: '72px' }}>
        <div className="flex items-center justify-center gap-3 flex-wrap">
          <span className="inline-flex items-center gap-1 bg-[#C0392B] text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
            <i className="ri-alarm-line w-4 h-4 flex items-center justify-center"></i>
            期間限定
          </span>
          <p
            className="text-[#3E2723] font-bold text-sm md:text-base tracking-wide whitespace-nowrap"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            🎉 不用品回収セットで買取金額
            <span className="text-[#C0392B] text-lg md:text-xl font-black mx-1">10%UP</span>
            キャンペーン実施中！
          </p>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-block bg-[#C0392B] text-white text-xs font-bold px-4 py-1.5 rounded-full hover:bg-[#A93226] transition-colors whitespace-nowrap cursor-pointer"
          >
            今すぐ申し込む →
          </a>
        </div>
      </div>

      {/* Full-Width Cinematic Background Image */}
      <div className="relative w-full" style={{ height: 'calc(100vh - 72px - 52px)' }}>
        <img
          src="https://public.readdy.ai/ai/img_res/04a106103fc6b5f3fbb9877234718e7e.jpg"
          alt="高級和風インテリア"
          className="w-full h-full object-cover object-center"
        />
        {/* Subtle Gradient Overlay at Bottom Only */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
      </div>
    </section>
  );
}
